import _extends from "@babel/runtime/helpers/esm/extends";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from "react";
import ClassNames from "classnames";
import Navigation from "./navigation/Navigation";
import DecadeView from "./decade-view/DecadeView";
import YearView from "./year-view/YearView";
import MonthView from "./month-view/MonthView";
import { getValueRange } from "../utils/dates";
import { callIfDefined, mergeFunctions, getLimitedViews, getValueType, getDetailValueFrom } from "../utils/utils";
import { getFirstFocusDate, getKeyTable, getBeginValueForKeyboardHover } from "../utils/NavUtils";
import { moveToNextDate } from "../utils/dateUtilsOld";
import { VIEWS, CALENDAR_PANEL, PREV_BUTTON, MONTH_BUTTON, YEAR_BUTTON, NEXT_BUTTON, PRIMARY_YEAR_VIEW_YEAR_BUTTON, SECONDARY_YEAR_VIEW_YEAR_BUTTON } from '../utils/constants';
var _weekday = [];
_weekday[0] = "Su";
_weekday[1] = "Mo";
_weekday[2] = "Tu";
_weekday[3] = "We";
_weekday[4] = "Th";
_weekday[5] = "Fr";
_weekday[6] = "Sa";
function innerFormatShortWeekday(locale, date) {
  locale = locale && locale.toLowerCase();
  if (!locale || locale.includes("en")) {
    //english based on the design
    return _weekday[date.getDay()];
  } else if (locale === "ko" || locale === "ja") {
    //japan and korean
    return date.toLocaleString(locale, {
      weekday: "long"
    })[0];
  } else {
    //other locale
    var res = date.toLocaleString(locale, {
      weekday: "long"
    });
    res = res.length > 3 ? res.substr(0, 3) : res;
    return res;
  }
}
var Calendar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Calendar, _Component);
  function Calendar(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.prevButtonDisabled = void 0;
    _this.nextButtonDisabled = void 0;
    _this.lastHoverTime = void 0;
    _this.onKeyDownForbid = false;
    _this.resetKeyboardNavInfo = function () {
      _this.setState({
        keyboardNavDate: null,
        keyboardControlArea: null
      });
    };
    _this.onKeyDown = function (e) {
      if (!e.altKey && !e.ctrlKey && _this.props.setIsUsingKeyboard) {
        _this.props.setIsUsingKeyboard(true);
      }
      var _this$props = _this.props,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        disabled = _this$props.disabled,
        _isInDoubleCalendar = _this$props._isInDoubleCalendar,
        maxDetail = _this$props.maxDetail,
        activeStartDate = _this$props.activeStartDate,
        value = _this$props.value,
        keyboardControlAreaDispatch = _this$props.keyboardControlAreaDispatch,
        keyboardNavDate = _this$props.keyboardNavDate,
        view = _this$props.view,
        keyboardControlArea = _this$props.keyboardControlArea,
        activeStartDateDispatch = _this$props.activeStartDateDispatch,
        openStatusDispatch = _this$props.openStatusDispatch,
        dateValidator = _this$props.dateValidator,
        disabledDates = _this$props.disabledDates,
        disabledDays = _this$props.disabledDays,
        disabledRanges = _this$props.disabledRanges;
      var _getKeyTable = getKeyTable(e),
        isTab = _getKeyTable.isTab,
        isEnter = _getKeyTable.isEnter,
        isDirection = _getKeyTable.isDirection,
        isChar = _getKeyTable.isChar,
        isBackspace = _getKeyTable.isBackspace,
        isSpace = _getKeyTable.isSpace,
        isEsc = _getKeyTable.isEsc;
      if (isEsc) {
        openStatusDispatch({
          type: 'close',
          payload: {
            isKeyboard: true
          }
        });
        keyboardControlAreaDispatch({
          type: "setInputFocus",
          payload: {
            isKeyboard: true
          }
        });
      }
      if (!isEsc && !_isInDoubleCalendar) {
        e.stopPropagation();
      }

      //When focused item is inside the nav area,
      //when press direction button, it will change to calendar date area. 
      var keyboardControlAreaIsNav = keyboardControlArea === MONTH_BUTTON || keyboardControlArea === YEAR_BUTTON || keyboardControlArea === PREV_BUTTON || keyboardControlArea === NEXT_BUTTON;

      //For double calendar, the function will stop here
      if (disabled || _isInDoubleCalendar && !isEnter) {
        return;
      }
      if (!isChar && !isBackspace && !isSpace && !isTab) {
        e.preventDefault && e.preventDefault();
      }
      var beginValue = getBeginValueForKeyboardHover(value, activeStartDate, view);

      //when keyboard in navigation and press direction,
      //the focus area will go to the date panel.
      if (keyboardControlAreaIsNav && isDirection) {
        keyboardControlAreaDispatch({
          type: 'setNav',
          payload: {
            keyboardNavDate: getFirstFocusDate(value, view, activeStartDate),
            keyboardControlArea: CALENDAR_PANEL
          }
        });
        return;
      }
      if (isTab) {
        e.preventDefault && e.preventDefault();
        keyboardControlAreaDispatch({
          type: 'setNavWhenPressTab',
          payload: {
            value: value,
            event: e
          }
        });
      } else if (keyboardControlArea === CALENDAR_PANEL && isDirection) {
        var temp = moveToNextDate(e, view, beginValue, keyboardNavDate, activeStartDate, minDate, maxDate);
        keyboardControlAreaDispatch({
          type: 'setNav',
          payload: {
            keyboardNavDate: temp.keyboardNavDate,
            keyboardControlArea: CALENDAR_PANEL
          }
        });
        activeStartDateDispatch({
          type: "setActiveStartDate",
          payload: {
            activeStartDateLeft: temp.activeStartDate
          }
        });
      } else if (isEnter) {
        if (keyboardNavDate && keyboardControlArea !== null && keyboardControlArea !== void 0 && keyboardControlArea.includes && keyboardControlArea.includes(CALENDAR_PANEL)) {
          if (view === maxDetail) {
            if (dateValidator.isValidDateValueByRules({
              date: keyboardNavDate,
              minDate: minDate,
              maxDate: maxDate,
              disabledDates: disabledDates,
              disabledDays: disabledDays,
              disabledRanges: disabledRanges,
              maxDetail: maxDetail
            })) {
              _this.onChange(keyboardNavDate, null, true);
            }
          } else {
            _this.onDrillDown(keyboardNavDate, e);
          }
        } else if (keyboardControlArea === MONTH_BUTTON) {
          _this.onDrillUp(activeStartDate, VIEWS.YEAR);
          //when press month button, it will focus 
          //on the month view's date panel. 
          //The first focus date is depend on value.
          _this.setState({
            keyboardControlArea: CALENDAR_PANEL,
            keyboardNavDate: getFirstFocusDate(value, _this.state.view, _this.state.activeStartDate)
          });
        } else if (keyboardControlArea === YEAR_BUTTON || keyboardControlArea === PRIMARY_YEAR_VIEW_YEAR_BUTTON || keyboardControlArea === SECONDARY_YEAR_VIEW_YEAR_BUTTON) {
          _this.onDrillUp(activeStartDate, VIEWS.DECADE);
          //when press year button, it will focus 
          //on the year view's date panel. 
          //The first focus date is depend on value.
          _this.setState({
            keyboardControlArea: CALENDAR_PANEL,
            keyboardNavDate: getFirstFocusDate(value, _this.state.view, _this.state.activeStartDate)
          });
        } else if (!isNaN(Number(keyboardControlArea))) {
          if (_this.props.onKeyDownForMenuMode) _this.props.onKeyDownForMenuMode(keyboardControlArea);
        }
      }
    };
    _this.setActiveStartDate = function (activeStartDate) {
      var onActiveDateChange = _this.props.onActiveDateChange;
      _this.setState({
        activeStartDate: activeStartDate,
        keyboardNavDate: null
      }, function () {
        var view = _this.state.view;
        callIfDefined(onActiveDateChange, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    };
    _this.onDrillDown = function (activeStartDate, event) {
      var _this$props2 = _this.props,
        viewDispatch = _this$props2.viewDispatch,
        activeStartDateDispatch = _this$props2.activeStartDateDispatch,
        keyboardControlAreaDispatch = _this$props2.keyboardControlAreaDispatch,
        value = _this$props2.value;
      viewDispatch({
        type: 'drillDown'
      });
      activeStartDateDispatch({
        type: 'setActiveStartDate',
        payload: {
          activeStartDateLeft: activeStartDate
        }
      });
      keyboardControlAreaDispatch({
        type: "setNavWhenDrillDown",
        payload: {
          event: event,
          value: value
        }
      });
    };
    _this.onDrillUp = function (event, target) {
      var _this$props3 = _this.props,
        viewDispatch = _this$props3.viewDispatch,
        keyboardControlAreaDispatch = _this$props3.keyboardControlAreaDispatch,
        activeStartDateDispatch = _this$props3.activeStartDateDispatch,
        activeStartDate = _this$props3.activeStartDate,
        maxDetail = _this$props3.maxDetail,
        minDetail = _this$props3.minDetail,
        view = _this$props3.view,
        value = _this$props3.value;
      viewDispatch({
        type: 'drillUp',
        payload: {
          targetView: target
        }
      });
      keyboardControlAreaDispatch({
        type: "setNavWhenDrillUp",
        payload: {
          event: event,
          value: value
        }
      });
      activeStartDateDispatch({
        type: 'setActiveStartDateWhenDrillUp',
        payload: {
          view: view,
          activeStartDate: activeStartDate,
          minDetail: minDetail,
          maxDetail: maxDetail,
          target: target
        }
      });
    };
    _this.onChange = function (value, event, isKeyboard) {
      if (isKeyboard === void 0) {
        isKeyboard = false;
      }
      var _this$props4 = _this.props,
        selectRange = _this$props4.selectRange,
        _isInDoubleCalendar = _this$props4._isInDoubleCalendar,
        enforceTwoValue = _this$props4.enforceTwoValue,
        valueDispatch = _this$props4.valueDispatch,
        inputValueDispatch = _this$props4.inputValueDispatch,
        _this$props4$autoClos = _this$props4.autoClose,
        autoClose = _this$props4$autoClos === void 0 ? true : _this$props4$autoClos,
        openStatusDispatch = _this$props4.openStatusDispatch,
        editable = _this$props4.editable,
        keyboardControlAreaDispatch = _this$props4.keyboardControlAreaDispatch,
        momentUtils = _this$props4.momentUtils;
      var getStartDate = momentUtils.getStartDate;
      if (_isInDoubleCalendar) {
        return;
      }
      var nextValue;
      if (selectRange) {
        var previousValue = _this.props.value;
        // Range selection turned on
        // 0 or 2 - either way we're starting a new array
        if (!previousValue || [].concat(previousValue).length !== 1) {
          // First value
          nextValue = getStartDate(value, _this.valueType);
        } else {
          // Second value
          if (enforceTwoValue && momentUtils.isSame(previousValue, value)) {
            if (autoClose) {
              openStatusDispatch({
                type: "close",
                payload: {
                  isKeyboard: isKeyboard
                }
              });
            }
            return;
          }
          if (autoClose) {
            openStatusDispatch({
              type: "close",
              payload: {
                isKeyboard: isKeyboard
              }
            });
          }
          nextValue = getValueRange(_this.valueType, previousValue, value, momentUtils);
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);
        if (autoClose) {
          openStatusDispatch({
            type: "close",
            payload: {
              isKeyboard: isKeyboard
            }
          });
        }
      }
      valueDispatch({
        type: "setValue",
        payload: {
          value: nextValue
        }
      });
      inputValueDispatch({
        type: "setInputValueByDate",
        payload: {
          value: nextValue
        }
      });
      var shouldFocus = autoClose && (selectRange && nextValue && nextValue.length === 2 || !selectRange);
      if (shouldFocus) {
        //must clear nav date or the input will not be able to focused.
        keyboardControlAreaDispatch({
          type: "clearNav"
        });
        if (editable) {
          keyboardControlAreaDispatch({
            type: "setInputFocus",
            payload: {
              isKeyboard: isKeyboard
            }
          });
        }
      }
    };
    _this.onMouseOver = function (value) {
      if (_this.props._onHover) {
        _this.props._onHover(value);
      } else {
        _this.setState({
          hover: value
        });
      }
    };
    _this.onMouseDown = function () {
      if (!_this.props.showInPicker) {
        _this.setState({
          allowOutline: false
        });
      }
    };
    _this.state = {
      view: _this.props.view,
      keyboardNavDate: null,
      keyboardControlArea: null,
      allowOutline: true,
      valueProps: null,
      hover: null,
      activeRange: null
    };
    return _this;
  }
  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.hover !== state.checked) {
      return {
        hover: props.hover
      };
    }
    return null;
  };
  var _proto = Calendar.prototype;
  _proto.clearKeyboard = function clearKeyboard() {
    this.setState({
      keyboardNavDate: null,
      keyboardControlArea: null
    });
  };
  _proto.cleanTempValue = function cleanTempValue() {
    this.setState({
      keyboardNavDate: null,
      keyboardControlArea: null,
      view: 'month'
    });
  };
  /**
   * Gets current value in a desired format.
   */
  _proto.getProcessedValue = function getProcessedValue(value) {
    var _this$props5 = this.props,
      minDate = _this$props5.minDate,
      maxDate = _this$props5.maxDate,
      maxDetail = _this$props5.maxDetail,
      momentUtils = _this$props5.momentUtils;
    return getDetailValueFrom(value, minDate, maxDate, maxDetail, momentUtils);
  };
  _proto.isViewAllowed = function isViewAllowed(props, view) {
    if (props === void 0) {
      props = this.props;
    }
    if (view === void 0) {
      view = this.state.view;
    }
    var views = getLimitedViews(props.minDetail, props.maxDetail);
    return views.indexOf(view) !== -1;
  };
  _proto.getView = function getView(props) {
    if (props === void 0) {
      props = this.props;
    }
    var _props = props,
      view = _props.view;
    if (view && getLimitedViews(props.minDetail, props.maxDetail).indexOf(view) !== -1) {
      return view;
    }
    return getLimitedViews(props.minDetail, props.maxDetail).pop();
  }

  //set the first focused date when focus from navigation to date panel

  /* 
   * The handler of key down. The method only controls the behaviour 
   * of keydown for single calendar. 
   * For double calendar, it will return in line 381.
   * The behaviour will be handled by onKeyDown method in DoubleCalendar
   */;
  _proto.renderContent = function renderContent() {
    var _this$props6 = this.props,
      locale = _this$props6.locale,
      maxDate = _this$props6.maxDate,
      minDate = _this$props6.minDate,
      selectRange = _this$props6.selectRange,
      tileDisabled = _this$props6.tileDisabled,
      disabled = _this$props6.disabled,
      disabledDates = _this$props6.disabledDates,
      disabledRanges = _this$props6.disabledRanges,
      disabledDays = _this$props6.disabledDays,
      activeStartDate = _this$props6.activeStartDate,
      view = _this$props6.view,
      value = _this$props6.value,
      keyboardNavDate = _this$props6.keyboardNavDate;
    var onMouseOver = this.onMouseOver,
      valueType = this.valueType;

    //two names for one property
    tileDisabled = tileDisabled || disabled;
    var hover = this.state.hover;
    var commonProps = {
      activeStartDate: activeStartDate,
      hover: hover,
      locale: locale,
      maxDate: maxDate,
      minDate: minDate,
      onMouseOver: selectRange ? onMouseOver : null,
      tileDisabled: tileDisabled,
      value: value,
      valueType: valueType,
      keyboardNavDate: keyboardNavDate,
      selectRange: selectRange,
      disabledDates: disabledDates,
      disabledRanges: disabledRanges,
      disabledDays: disabledDays
    };
    var clickAction = this.drillDownAvailable ? this.onDrillDown : this.onChange;
    switch (view) {
      case VIEWS.DECADE:
        {
          var onClickYear = this.props.onClickYear;
          return /*#__PURE__*/React.createElement(DecadeView, _extends({
            onClick: mergeFunctions(clickAction, onClickYear)
          }, commonProps));
        }
      case VIEWS.YEAR:
        {
          var onClickMonth = this.props.onClickMonth;
          return /*#__PURE__*/React.createElement(YearView, _extends({
            formatMonth: this.props.formatMonth,
            onClick: mergeFunctions(clickAction, onClickMonth)
          }, commonProps));
        }
      case VIEWS.MONTH:
        {
          var _this$props7 = this.props,
            formatShortWeekday = _this$props7.formatShortWeekday,
            onClickDay = _this$props7.onClickDay,
            showOtherMonths = _this$props7.showOtherMonths,
            firstDayOfWeek = _this$props7.firstDayOfWeek;
          return /*#__PURE__*/React.createElement(MonthView, _extends({
            formatShortWeekday: formatShortWeekday || innerFormatShortWeekday,
            onClick: mergeFunctions(clickAction, onClickDay),
            showOtherMonths: showOtherMonths,
            firstDayOfWeek: firstDayOfWeek
          }, commonProps));
        }
      default:
        throw new Error("Invalid view: " + view + ".");
    }
  };
  _proto.renderNavigation = function renderNavigation() {
    var _this$props8 = this.props,
      formatMonthYear = _this$props8.formatMonthYear,
      locale = _this$props8.locale,
      maxDate = _this$props8.maxDate,
      maxDetail = _this$props8.maxDetail,
      minDate = _this$props8.minDate,
      minDetail = _this$props8.minDetail,
      nextLabel = _this$props8.nextLabel,
      navigationLabel = _this$props8.navigationLabel,
      prevLabel = _this$props8.prevLabel,
      navigationLayoutMode = _this$props8.navigationLayoutMode,
      _isInDoubleCalendar = _this$props8._isInDoubleCalendar,
      showNavigation = _this$props8.showNavigation,
      disabled = _this$props8.disabled,
      showNavigationPrevNextBtn = _this$props8.showNavigationPrevNextBtn,
      onActiveDateChangeNoDir = _this$props8.onActiveDateChangeNoDir,
      calendarPosition = _this$props8.calendarPosition,
      view = _this$props8.view,
      keyboardControlArea = _this$props8.keyboardControlArea;
    if (!showNavigation) {
      return null;
    }
    var activeRange = this.state.activeRange;
    return /*#__PURE__*/React.createElement(Navigation, {
      activeRange: activeRange,
      drillUp: this.onDrillUp,
      formatMonthYear: formatMonthYear,
      locale: locale,
      maxDate: maxDate,
      minDate: minDate,
      navigationLayoutMode: navigationLayoutMode,
      keyboardControlArea: keyboardControlArea,
      nextLabel: nextLabel,
      navigationLabel: navigationLabel,
      _isInDoubleCalendar: _isInDoubleCalendar,
      prevLabel: prevLabel,
      setActiveStartDate: this.setActiveStartDate,
      onActiveDateChangeNoDir: onActiveDateChangeNoDir,
      view: view,
      middleDisabled: !this.drillUpAvailable,
      disabled: disabled,
      views: getLimitedViews(minDetail, maxDetail),
      showNavigationPrevNextBtn: showNavigationPrevNextBtn,
      calendarPosition: calendarPosition
    });
  };
  _proto.render = function render() {
    var _this$props9 = this.props,
      className = _this$props9.className,
      selectRange = _this$props9.selectRange,
      value = _this$props9.value;
    var valueArray = [].concat(value);
    var cn = ClassNames("ap-calendar", className, {
      "ap-calendar--selectRange": selectRange && valueArray.length === 1,
      "a-calendar-no-outline": !this.state.allowOutline
    });
    return /*#__PURE__*/React.createElement("div", {
      className: cn,
      tabIndex: -1,
      onMouseDown: this.onMouseDown,
      onKeyDown: this.onKeyDown.bind(this),
      style: {
        outline: "none"
      }
    }, this.renderNavigation(), this.renderContent());
  };
  _createClass(Calendar, [{
    key: "drillDownAvailable",
    get: function get() {
      var _this$props10 = this.props,
        maxDetail = _this$props10.maxDetail,
        minDetail = _this$props10.minDetail,
        view = _this$props10.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var _this$props11 = this.props,
        maxDetail = _this$props11.maxDetail,
        minDetail = _this$props11.minDetail,
        view = _this$props11.view;
      var views = getLimitedViews(minDetail, maxDetail);
      var index = views.indexOf(view);
      return index > 0;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }]);
  return Calendar;
}(Component);
Calendar.defaultProps = {
  maxDetail: "month",
  minDetail: "decade",
  showNavigation: true,
  showOtherMonths: true,
  enforceTwoValue: false
};
export { Calendar as default };